import { RouteObject } from "react-router-dom";
import { Financial } from "./list";

export const FinancialRouter: RouteObject = {
  path: "/financial",
  handle: { crumb: () => "Cadastros / Financeiro" },
  children: [
    {
      index: true,
      element: <Financial />,
    },
  ],
  errorElement: <h1>Route not found!</h1>,
};
